import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
	AlertController,
	ModalController,
	PopoverController,
} from '@ionic/angular';
import { Observable } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { studentsFormField } from './forms/create-students';
import { StudentsService } from './service/students.service';

@Component({
	selector: 'app-students',
	templateUrl: './students.page.html',
	styleUrls: ['./students.page.scss'],
})
export class StudentsPage implements OnInit {
	shortCode: any = '';
	getStudentsList$: Observable<any> | undefined;
	constructor(
		private route: ActivatedRoute,
		private studentsService: StudentsService,
		public popoverController: PopoverController,
		public modalController: ModalController,
		private alertController: AlertController,
	) {}

	ngOnInit() {
		this.shortCode = this.route.snapshot.paramMap.get('shortCode');

		this.studentsService.loadStudentInit(this.shortCode);
		this.studentsService.loadStudentApi(this.shortCode).subscribe();
		this.getStudentsList$ = this.studentsService.loadStudentData(
			this.shortCode,
		);
	}
	isCanOpenBox = true;

	async createStudents() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Create Students',
					form: studentsFormField,
					onSubmitForm: this.onCreate,
					ref: this,
					values: {
						username: this.shortCode + '-',
						b2bFlag: this.shortCode,
					},
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onCreate(ref: any, editForm: any) {
		return ref.studentsService.addStudents({
			...editForm,
			roles: [],
			title: '',
			country: '',
			state: '',
			city: '',
			address: '',
			shortDescription: '',
			description: '',
			email: editForm.username + '@' + editForm.b2bFlag + '.terra.do',
		});
		// return this.faqService.updateFaq(this.jobfairId, editForm.id, editForm);
	}

	async updatePassword(data: any) {
		const alert = await this.alertController.create({
			header: 'Enter Password for ' + data.email,
			buttons: [
				{
					text: 'OK',
					role: 'confirm',
					handler: data1 => {
						this.studentsService
							.updatePassword(data.email, data1[0])
							.subscribe(() => {});
					},
				},
			],
			inputs: [
				{
					placeholder: 'Password',
				},
			],
		});

		await alert.present();
	}

	updateStudentOnboarding(data: any, currentStatus: any) {
		if (!currentStatus.value) {
			this.studentsService.updateOnboardingFalse(data.userId).subscribe(() => {
				// this.getJobfairSchedule(this.jobfairId);
			});
		} else {
			this.studentsService.updateOnboarding(data.email).subscribe(() => {
				// this.getJobfairSchedule(this.jobfairId);
			});
		}
	}
}
